module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-container"
  }, [_c('el-tabs', {
    model: {
      value: (_vm.activeName),
      callback: function($$v) {
        _vm.activeName = $$v
      },
      expression: "activeName"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": "返校记录",
      "name": "first"
    }
  }, [(_vm.type === 'mobile') ? _c('div', [_c('el-form', {
    attrs: {
      "label-width": "80px",
      "label-position": "left",
      "width": "100%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "班级"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.form.className) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "返校时间"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.form.date) + "\n                    ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "返校地点"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.form.site) + "\n                    ")]), _vm._v(" "), _c('el-form', {
    attrs: {
      "label-position": "top",
      "width": "100%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "返校主题"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.form.theme) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "返校情况"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.form.situation) + "\n                        ")])], 1)], 1)], 1) : _c('div', {
    staticStyle: {
      "height": "500px",
      "overflow": "auto"
    }
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "label-width": "80px",
      "label-position": "left",
      "width": "100%",
      "rules": _vm.rules
    }
  }, [_c('el-row', [_c('el-form-item', {
    attrs: {
      "label": "班级",
      "prop": "classCode"
    }
  }, [(_vm.recType === 'add') ? _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择班级",
      "clearable": ""
    },
    model: {
      value: (_vm.form.classCode),
      callback: function($$v) {
        _vm.$set(_vm.form, "classCode", $$v)
      },
      expression: "form.classCode"
    }
  }, _vm._l((_vm.comboOption.class), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1) : _vm._e(), _vm._v(" "), (_vm.recType !== 'add') ? _c('span', [_vm._v(_vm._s(_vm.form.className))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "返校时间",
      "prop": "date"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择返校时间",
      "type": "date",
      "value-format": "yyyy-MM-dd",
      "readonly": _vm.userType === 'stu'
    },
    model: {
      value: (_vm.form.date),
      callback: function($$v) {
        _vm.$set(_vm.form, "date", $$v)
      },
      expression: "form.date"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "返校地点",
      "prop": "site"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入返校地点",
      "maxlength": "100",
      "readonly": _vm.userType === 'stu'
    },
    model: {
      value: (_vm.form.site),
      callback: function($$v) {
        _vm.$set(_vm.form, "site", $$v)
      },
      expression: "form.site"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    attrs: {
      "label": "返校主题",
      "prop": "theme"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "maxlength": "500",
      "show-word-limit": "",
      "readonly": _vm.userType === 'stu'
    },
    model: {
      value: (_vm.form.theme),
      callback: function($$v) {
        _vm.$set(_vm.form, "theme", $$v)
      },
      expression: "form.theme"
    }
  })], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-form-item', {
    attrs: {
      "label": "返校情况",
      "prop": "situation"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "maxlength": "500",
      "show-word-limit": "",
      "readonly": _vm.userType === 'stu'
    },
    model: {
      value: (_vm.form.situation),
      callback: function($$v) {
        _vm.$set(_vm.form, "situation", $$v)
      },
      expression: "form.situation"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), (_vm.userType !== 'stu') ? _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "margin-bottom": "20px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveRec
    }
  }, [_vm._v("保 存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": _vm.callback
    }
  }, [_vm._v("关 闭")])], 1) : _vm._e()]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "学生出勤",
      "name": "second"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "500px",
      "overflow": "auto"
    }
  }, [(_vm.userType === 'stu') ? _c('div', [_c('el-form', {
    attrs: {
      "label-width": "80px",
      "label-position": "left",
      "width": "100%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "出勤状态"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.parseAttendance(_vm.stuAttendanceInfo)) + "\n                        ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "情况说明"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.stuAttendanceInfo.situation) + "\n                        ")])], 1)], 1) : _c('div', [(_vm.recType === 'add') ? _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "font-size": "18px",
      "font-weight": "bold",
      "color": "#a7a8ac",
      "margin-top": "50px"
    }
  }, [_vm._v("\n                        首次保存返校记录后可修改学生出勤信息\n                    ")]) : _c('div', [_c('div', {
    staticClass: "filter-container"
  }, [_c('el-input', {
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "placeholder": "学号 / 姓名",
      "clearable": ""
    },
    model: {
      value: (_vm.queryStuForm.stuCode),
      callback: function($$v) {
        _vm.$set(_vm.queryStuForm, "stuCode", $$v)
      },
      expression: "queryStuForm.stuCode"
    }
  }), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "10px"
    },
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.loadStuAttendance
    }
  }, [_c('i', {
    staticClass: "el-icon-search"
  }), _vm._v(" 查询\n                            ")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "gray"
    },
    on: {
      "click": _vm.handleReset
    }
  }, [_c('i', {
    staticClass: "el-icon-refresh"
  }), _vm._v(" 重置\n                            ")])], 1), _vm._v(" "), _c('el-table', {
    ref: "mainTable",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "stripe": "",
      "border": "",
      "fit": "",
      "highlight-current-row": "",
      "header-cell-class-name": "tableHeadStyle",
      "height": "400px"
    },
    on: {
      "selection-change": _vm.handleSelection
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "index",
      "index": _vm.indexMethod,
      "align": "center"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "学号",
      "prop": "stuCode",
      "align": "center",
      "width": "150px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "姓名",
      "prop": "stuName",
      "align": "center",
      "width": "150px"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "出勤状态",
      "align": "center",
      "width": "100px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-select', {
          on: {
            "change": function($event) {
              return _vm.changeAttendanceState(scope.row)
            }
          },
          model: {
            value: (scope.row.attendance),
            callback: function($$v) {
              _vm.$set(scope.row, "attendance", $$v)
            },
            expression: "scope.row.attendance"
          }
        }, _vm._l((_vm.comboOption.attendance), function(item) {
          return _c('el-option', {
            key: item.comboValue,
            attrs: {
              "label": item.comboName,
              "value": item.comboValue
            }
          })
        }), 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "情况说明",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          attrs: {
            "maxlength": "500"
          },
          on: {
            "blur": function($event) {
              return _vm.changeSituation(scope.row)
            }
          },
          model: {
            value: (scope.row.situation),
            callback: function($$v) {
              _vm.$set(scope.row, "situation", $$v)
            },
            expression: "scope.row.situation"
          }
        })]
      }
    }])
  })], 1)], 1)])])]), _vm._v(" "), _c('el-tab-pane', {
    attrs: {
      "label": "学生返校照片",
      "name": "third"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "500px",
      "overflow": "auto"
    }
  }, [(_vm.recType === 'add') ? _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "font-size": "18px",
      "font-weight": "bold",
      "color": "#a7a8ac",
      "margin-top": "50px"
    }
  }, [_vm._v("\n                    首次保存返校记录后可上传照片\n                ")]) : _c('div', [(_vm.userType === 'stu') ? _c('el-upload', {
    class: 'hidden-Btn',
    attrs: {
      "accept": ".png,.jpeg,.jpg",
      "action": "",
      "http-request": _vm.uploadPhoto,
      "file-list": _vm.fileImgList,
      "list-type": "picture-card",
      "disabled": true,
      "on-preview": _vm.handlePictureCardPreview
    },
    scopedSlots: _vm._u([{
      key: "file",
      fn: function(ref) {
        var file = ref.file;

        return [_c('div', {
          staticClass: "el-upload-list__item-thumbnail"
        }, [_c('img', {
          attrs: {
            "width": "146px",
            "height": "146px",
            "src": file.url,
            "alt": ""
          }
        })]), _vm._v(" "), _c('span', {
          staticClass: "el-upload-list__item-actions"
        }, [_c('span', {
          staticClass: "el-upload-list__item-preview",
          on: {
            "click": function($event) {
              return _vm.handlePictureCardPreview(file)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-zoom-in"
        })]), _vm._v(" "), (_vm.userType !== 'stu') ? _c('span', {
          staticClass: "el-upload-list__item-delete",
          on: {
            "click": function($event) {
              return _vm.handleRemove(file)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        })]) : _vm._e()])]
      }
    }], null, false, 780988138)
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]) : _vm._e(), _vm._v(" "), (_vm.userType !== 'stu') ? _c('el-upload', {
    attrs: {
      "accept": ".png,.jpeg,.jpg",
      "action": "",
      "http-request": _vm.uploadPhoto,
      "file-list": _vm.fileImgList,
      "list-type": "picture-card",
      "on-preview": _vm.handlePictureCardPreview,
      "on-remove": _vm.handleRemove
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]) : _vm._e(), _vm._v(" "), (_vm.previewerVisible) ? _c('previewer', {
    ref: "previewer",
    attrs: {
      "fileInfo": _vm.fileInfo,
      "widthPercent": 60,
      "heightNum": 650,
      "topNum": 60
    },
    on: {
      "closePreviewer": function($event) {
        _vm.previewerVisible = false;
      }
    }
  }) : _vm._e()], 1)])]), _vm._v(" "), (_vm.modSituationDialogVisible) ? _c('el-dialog', {
    attrs: {
      "title": "编辑",
      "visible": _vm.modSituationDialogVisible,
      "top": "150px",
      "width": "650px",
      "append-to-body": ""
    },
    on: {
      "update:visible": function($event) {
        _vm.modSituationDialogVisible = $event
      }
    }
  }, [_c('el-form', {
    attrs: {
      "label-width": "80px",
      "label-position": "left",
      "width": "100%"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "学号"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.modSituationForm.stuCode) + "\n                ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "姓名"
    }
  }, [_vm._v("\n                    " + _vm._s(_vm.modSituationForm.stuName) + "\n                ")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "出勤状态"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "placeholder": "请选择出勤状态",
      "clearable": ""
    },
    model: {
      value: (_vm.modSituationForm.attendance),
      callback: function($$v) {
        _vm.$set(_vm.modSituationForm, "attendance", $$v)
      },
      expression: "modSituationForm.attendance"
    }
  }, _vm._l((_vm.comboOption.attendance), function(item, index) {
    return _c('el-option', {
      key: item.comboValue,
      attrs: {
        "value": item.comboValue,
        "label": item.comboName
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "情况说明"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "rows": 5,
      "maxlength": "500",
      "show-word-limit": ""
    },
    model: {
      value: (_vm.modSituationForm.situation),
      callback: function($$v) {
        _vm.$set(_vm.modSituationForm, "situation", $$v)
      },
      expression: "modSituationForm.situation"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "text-align": "center",
      "margin-top": "20px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.saveModSituation
    }
  }, [_vm._v("保 存")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.modSituationDialogVisible = false
      }
    }
  }, [_vm._v("取 消")])], 1), _vm._v(" "), _c('br')], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-65d0e030"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/postPracticeManage/homecomingRecord.vue
// module id = 1848
// module chunks = 502